// removed by extract-text-webpack-plugin
module.exports = {"chip":"_1Z7LJwm8WDjSPwC-2ZUiaF","avatar":"OrZu6C9h5yja1qWElm3wg","deletable":"rA-Ex_UGJ5mlbX298egQO","delete":"_2dSJTgi0Mgv12Dx4Xm3m4B","deleteIcon":"_2rkJbe1profER5wJK3J7m6","deleteX":"mYsspVSf_4E1ZGbQHrhPN"};


//////////////////
// WEBPACK FOOTER
// ../~/react-toolbox/lib/chip/theme.scss
// module id = 963
// module chunks = 0